<template>
  <div class="block" style="padding: 0px;">
    <div class="block-wrap">
      <div class="title-box" v-if="type == 'home'">
        <h2 class="h2">项目展示</h2>
        <router-link to="/project?type=1" class="lookMore">查看更多<i class="el-icon-arrow-right" /></router-link>
      </div>
    </div>
    <div class="block-wrap news_wrap">
      <div class="contentBlock">{{content}}</div>
      <div class="news_detail" style="flex-wrap: wrap;">
        <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="handleToNewsDetails(item.id)">
          <img :src="item.preview_image" class="picture" />
          <h2 class="h2">{{ item.title }}</h2>
          <div class="flex">
            <p class="desc">{{ item.jieshao }}</p>
            <el-button class="btn">立即捐赠</el-button>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="type != 'home'">
        <el-pagination layout="slot" :total="total" :current-page="page" hide-on-single-page>
          <div>
            <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
              <i class="el-icon-arrow-left"></i>
              上一页
            </el-button>
            <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
              下一页
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    cateList: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      newsList: [],
      page: 1,
      total: 0,
      lastPage: 1,
    };
  },
  computed: {
    ...mapState(["platform"]),
    isWrap() {
      if (this.platform == "mobile") {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    $route: {
      handler(to) {
        this.getList(this.cateList[to.params.id - 1].id);
      },
      immediate: true, // 首次加载立即执行
    },
  },
  methods: {
    async getList(id) {
      const params = {
        is_shouye_show: undefined,
        project_cate_id: id,
        limit: 6,
        page: 1,
      };
      const res = await CifuAPI.getProjectList(params);
      if (res.code == 1) {
        this.newsList = res.data.data;
        this.total = res.data.total;
        this.lastPage = res.data.last_page;
      }
    },
    handlePrevChange() {
      this.page--;
      this.getList();
    },
    handleNextChange() {
      this.page++;
      this.getList();
    },
    handleToNewsDetails(id) {
      this.$router.push("/projectDetail?type=1&id=" + id);
    },
  },
};
</script>

<style lang="scss" scoped>
.more {
  height: 50px;
  text-align: right;
}

.news_wrap {
//   min-width: 1400px; // 设置合理的固定宽度，类似韩红基金会
//   // 处理浏览器放大后的情况
//   @media screen and (min-width: 1401px) {
//     min-width: auto; // 1200px以上恢复完全响应式
//   }  
//   @media screen and (max-width: 1400px) {
//     min-width: 1400px; // 1200px以下固定宽度，不再缩小
//   // 处理浏览器放大后的情况
//   @media screen and (min-width: 1401px) {
//     min-width: auto; // 1200px以上恢复完全响应式
//   }
// }

  // 只在真正的移动设备上应用移动端样式
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   min-width: auto; // 移动端不限制最小宽度
  // }
  .news_detail {
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    gap: 60px;
    @media screen and (max-width: 1300px) {
      gap: 60px;
    }
    
    @media screen and (max-width: 1300px) {
      gap: 60px; // 1200px以下不再缩小
    }
    
    // 只在真正的移动设备上应用移动端样式
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   flex-direction: column;
    //   gap: 20px;
    // }
    .news-item {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      background: #fff;
      border-radius: 8px;
      flex-shrink: 0;
      overflow: hidden;
      // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      transition: transform 0.3s ease, box-shadow 0.3s ease;
      
      @media screen and (max-width: 1400px) {
        border-radius: 6px;
      }
      
      // @media screen and (max-width: 768px) {
      //   border-radius: 4px;
      // }
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        
        // @media screen and (max-width: 768px) {
        //   transform: none;
        //   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        // }
      }
      .picture {
        height: 280px;
        flex-shrink: 0;
        object-fit: cover;
        
        @media screen and (max-width: 1400px) {
          height: 260px;
        }
        
        @media screen and (max-width: 1400px) {
          height: 240px; // 1200px以下不再缩小
        }
        
        // @media screen and (max-width: 768px) {
        //   height: 180px;
        // }
        
        // @media screen and (max-width: 480px) {
        //   height: 160px;
        // }
      }
      .h2 {
        width: 100%;
        padding-top: 40px;
        padding-bottom: 14px;
        line-height: 28px;
        font-weight: bold;
        padding-left: 20px;
        font-size: 24px;
        color: #663301;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
          color: #d60c18;
        }
      }
      .flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 20px;
        padding-bottom: 20px;
        // @media screen and (max-width: 768px) {
        //   padding: 0 10px;
        // }
        // .desc {
        //   padding-right: 23px;
        //   padding-bottom: 0;
        //   @media screen and (max-width: 768px) {
        //     display: none;
        //   }
        // }
        // .btn {
        //   @media screen and (max-width: 768px) {
        //     width: 100%;
        //     height: 40px;
        //     font-size: 14px;
        //   }
        // }
      }
      .desc {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 控制显示行数 */
        overflow: hidden;
        text-overflow: ellipsis;
        padding-bottom: 12px;
        font-size: 18px;
        color: #4f4f4f;
        line-height: 24px;
        // @media screen and (max-width: 768px) {
        //   font-size: 14px;
        //   line-height: 20px;
        // }
      }
      .time {
        padding-bottom: 14px;
        font-size: 18px;
        color: #828282;
        line-height: 24px;
        // @media screen and (max-width: 768px) {
        //   font-size: 14px;
        //   line-height: 20px;
        // }
      }
    }
  }
}
.video {
  width: 100%;
  height: 300px;
  // @media screen and (max-width: 768px) {
  //   height: auto;
  // }
  &-list {
    display: flex;
    padding-top: 50px;
    // @media screen and (max-width: 768px) {
    //   padding-top: 20px;
    // }
  }
  &-item {
    flex: 1;
    width: 440px;
    // @media screen and (max-width: 768px) {
    //   width: calc(50% - 5px);
    // }
  }
  &-box {
    position: relative;
  }
  &-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2;
    .el-icon-video-play {
      position: absolute;
      right: 36px;
      bottom: 36px;
      font-size: 36px;
      color: #fff;
      z-index: 3;
    }
  }
  &-title {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 14px;
    line-height: 28px;
    font-weight: bold;
    font-size: 24px;
    color: #663301;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &-desc {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 控制显示行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    color: #4f4f4f;
    line-height: 24px;
  }
}
.contentBlock{
  padding-bottom: 60px;
  font-size: 16px;
}
</style>
